<template>
  <div class="hpCases reveal px-10vw">
    <div class="hpcCasesInner" >
        <!-- :style="getBg()" -->
        <!--
        <div class="casesVideoBg">
            <video loop="loop" muted="" id="compVideo1" playsinline="" src="https://360.mis-implants.com/img/video_bg.mp4"></video>
        </div>
        -->
        <div class="hpCasesTitle">{{localize('clinical_cases')}}</div>
        <div class="hpSecSub">
            <router-link :to="getMainPageLink" style="color:#fff;">
              {{localize('explore_clinical_cases')}} - <span style="color:#fff;">{{localize('view_all')}}</span>
              <!-- {{mediaChildren}} -- todo> convert or add the "video" to "url" -->
            </router-link>
        </div>

        <div :class="['caseBoxes']" ref="items">
            <div class="casesScroller" ref="casesScrolledElements">
            <ul>
                <li v-for="(item,index) in pageData" :key="'cases_'+index" class="caseBox">
                    <!-- <a target="_blank" :href="getItemCaseURL(item)"> -->
                    <div @click="clickHandler(item)">
                        <div class="caseImg fadeUpItem" :style="'--index:'+index">
                          <img :src="'https://mis-implants.com/upload/'+item.img">
                          <!-- <img :src="'img/_temp/recwhite.png'"> -->
                        </div>

                        <div class="caseName hpFont1 fadeUpItem" :style="'--addDelay:0.3s;--index:'+index">
                          {{item.subtitle}}
                        </div>

                        <div class="caseBorder" :style="'--addDelay:0.1s;--index:'+index">
                        </div>

                        <div class="caseTitle hpFont15 fadeUpItem" :style="'--addDelay:0.5s;--index:'+index">
                          <span>{{item.title}}</span>
                        </div>    

                        <div class="caseView fadeUpItem" :style="'--addDelay:0.7s;--index:'+index">
                            <span class="hpFont1" v-if="item.video">
                              <i class="fal fa-play"></i>{{localize('watch_video')}}
                            </span>          
                            <span class="hpFont1" v-else>
                              <i class="fal fa-file"></i>{{localize('view_publication')}}                              
                            </span>          
                        </div>
                    </div>
                </li>        
            </ul>
            </div>
        </div>

        
        <div class="casesPager">
            <sidepager
                @item-change = "onPagerChange"
                :skinMode="0"
                :itemIndex="currentPage" 
                :mobilePagesCount = "5"
                :itemsPerPage="itemsPerPage"
                :items="pageData">
            </sidepager>
        </div>

    </div>    
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import sidepager from "@/views/com/sidepager.vue";
export default {
  components: { sidepager },
  data() {
    return {
        itemsPerPage:4,
        scrWidth:0,
        currentPage:-1,
        activeIndex: 0,
        test:''
    };
  },
  props: {
    sectionData:{}
  },
  beforeDestroy() { 
    var vm = this;
    window.removeEventListener('resize', vm.onResize); 
  },
  mounted() {
    var vm = this;
    this.$nextTick(() => {
      vm.setMediaChildrenToGallery();

      window.addEventListener('resize', vm.onResize); 
      vm.onResize();     

      var scroller = this.$refs.casesScrolledElements;
      scroller.addEventListener("scroll", vm.checkScrollPos, false);

    })
  },
  watch: {
  },
  computed: {
    ...mapGetters(["localeString"]),
      mediaChildren() 
      {
          //filter only the video elements 
          let mediaArr = _.filter(this.pageData,child => child.video && /(vimeo|youtube)/g.test(child.video));
          let index = -1;
          mediaArr.forEach(function (element) 
          { 
            index++;
            element.id = index;           
            element.media_type_id = 5;
            element.url = element.video;//copy the video also to the "url" prop
            element.src = element.video;
            element.image = '';
          });
          return mediaArr;
          //return this.pageData;
          /*
          return _.filter(
              this.pageData,
              child => child.url && /(vimeo|youtube)/g.test(child.url));
              */
      },

    getMainPageLink()
    {
      return this.parsedLocaleString+"/science/research-library?categories=Clinical%20Cases";
      //return this.parsedLocaleString+"/research-and-development/research-library?categories=Clinical%20Cases";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    pageData()
    {
        //alert(this.sectionData.items[0].title);
      return this.sectionData.items;
    }

  },
  methods: 
  {
    ...mapActions(["setGalleryIndex", "setGalleryChildren"]),
    checkScrollPos()
    {
      var vm = this;
      var scroller = this.$refs.casesScrolledElements;
      let scrolledX = scroller.scrollLeft;      
      var scrollerWidth = scroller.getBoundingClientRect().width;
      var scrollerWrapperX = scroller.offsetLeft;      
      var scrolledInnerX = scrolledX - scrollerWrapperX;
      var reveals = scroller.querySelectorAll(".caseBox");    

      for (var i = 0; i < reveals.length; i++) 
      {
            let elOffsetX = reveals[i].offsetLeft;
            let diff = Math.abs(scrolledX-elOffsetX);
            if(this.itemsPerPage>1)
            {
                var isVisible = this.isElementVisible(scroller,reveals[i]);
                if(isVisible){
                  let pageIndexVisible = Math.floor(i/this.itemsPerPage);
                  vm.currentPage = pageIndexVisible;
                }
            }
            else{                
                if(diff<140){ //mobile mode
                    vm.currentPage = i;//this will update the pager buttons//mobile mode
                }
            }
        }
        if(scrolledX<100){
          vm.currentPage=0;
        }
    },       
    isElementVisible(container, element) 
    {
        const containerRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const isVisible = 
        (
            (elementRect.left+(containerRect.width/2)) >= containerRect.left &&
            elementRect.right <= containerRect.right
        );
        return isVisible;
    },

    onResize() 
    {
      var winWidth = window.innerWidth;
      this.scrWidth = winWidth;
      if(this.scrWidth<850)
      {
        //change the pager
        this.itemsPerPage = 1;
      }else{
        //change the pager
        this.itemsPerPage = 4;
      }
    },
    onPagerChange(index)
    {
      this.navTo(index);
    },
    navTo(index)
    {
      this.activeIndex = index;      
      var indexOfElement = index * this.itemsPerPage;//itemsInPage;
      //alert("indexOfElement="+indexOfElement);

      let scrollToElement = this.$refs.casesScrolledElements.getElementsByClassName("caseBox")[indexOfElement];

      scrollToElement.scrollIntoView(
      { 
          behavior: 'smooth',
          inline:'start',
          block:'nearest' }
      );      
    },
    initScrollListener() {
        var vm = this;
        let scroller = this.$refs.casesScrolledElements;
        scroller.addEventListener("scroll", vm.onThumbsScroll, false);
    },
    removeScrollListener() 
    {
        var vm = this;
        let scroller = this.$refs.casesScrolledElements;
        if(scroller!=null){
            scroller.removeEventListener("scroll", vm.onThumbsScroll);
        }
    },
    onThumbsScroll() {
        var vm = this;
        if (vm.scrollTimer != -1){clearTimeout(vm.scrollTimer);}                
        vm.scrollTimer = setTimeout(() => {
            vm.onThumbsScrollFinished();
        }, 50);            //500
    },
    onThumbsScrollFinished()
    {
        //Check the scroll position after the scroll has ended
        this.checkScrollPosition();
    },
    checkScrollPosition() {
        var vm=this;
        let scroller = this.$refs.casesScrolledElements;
        let scrolledX = scroller.scrollLeft;
        var reveals = scroller.querySelectorAll(".caseBox");        
        for (var i = 0; i < reveals.length; i++) {

            let diff = Math.abs(scrolledX-reveals[i].offsetLeft);
            //console.log("element:"+i+" diff:"+diff);
            if(diff<140){
                //.scrolledToIndex = i;
                //let itemsPerPage = 1;//on desktop
                //if(this.isMobile){
                    //itemsPerPage=1;//on mobile
                //}            
                //let pageIndex = i;//Math.floor(i);///itemsPerPage);
                //this.$emit('page-scrolled',pageIndex);
                //update the pager buttons
                vm.currentPage = i;//this will update the buttons
                vm.activeIndex = i;//this will update the thumbs
            }
        }
    },         

    setMediaChildrenToGallery() {
        this.$nextTick(function() {
            if (this.mediaChildren && this.mediaChildren.length) {
                this.setGalleryChildren(this.mediaChildren);
            }
        });
    },

    clickHandler(item)
    {
        if (item.video && item.video.length>0) 
        {
            let id = item.id,
            index = _.findIndex(this.mediaChildren, { id });
            this.setGalleryIndex(index);//index ///<<< SETTING THE INDEX WILL SHOW THE POPUP
        } 
        else if (this.isExternalLink(item)) {            
            window.open(item.url, "_blank"); //EXTERNAL LINK
        } 
        else {            
          window.open("https://mis-implants.com/upload/"+item.url, "_blank"); 
            //this.$router.push("upload/"+item.url); //INTERNAL LINK
        }
    },
    isMedia(item) {
        return item.url && /(vimeo|youtube)/g.test(item.url);
    },
    isExternalLink(item) {
        return item.url && /http/.test(item.url);
    },    
    fixHeights()
    {
      var scrW = window.screen.width;
      if(scrW>900)
      {
        var elements = this.$refs.items;
        var elTitles = elements.querySelectorAll('.caseTitle');
        var maxH = 0;
        for (var i = 0; i < elTitles.length; i++){
            var elH = elTitles[i].offsetHeight;
            if(elH>maxH){
              maxH=elH;            
            }
        }
        for (var i = 0; i < elTitles.length; i++){
            elTitles[i].style.height = maxH+"px";
        }
      }

    },
    getUrl(url)
    {
        let temp = caseURL.toLowerCase();
        if(temp.indexOf("http://")==0 || temp.indexOf("https://")==0){
            return url;
        }else{
            return "https://mis-implants.com/upload/"+url;
        }
    },
    getVideo(video)
    {
        return video;
    },    
    getItemCaseURL(item)
    {
        if(item.video)
        {
            return item.video;
        }
        else
        {
            let temp = item.url.toLowerCase();
            if(temp.indexOf("http://")==0 || temp.indexOf("https://")==0){
                return item.url;
            }else{
                return "https://mis-implants.com/upload/"+item.url;
            }
        }

    },
/*     <a target="_blank" :href="getCaseURL(item.url)" class="hpFont1" v-if="item.url">View Publication</a>          
    <a target="_blank" :href="item.video" class="hpFont1" v-if="item.video">
 */    ___getCaseURL(url)
    {
        let temp = url.toLowerCase();
        if(temp.indexOf("http://")==0 || temp.indexOf("https://")==0){
            return url;
        }else{
            return "https://mis-implants.com/upload/"+url;
        }
    },
    getBg()
    {
      return "background-image: url('img/bgCases6.png');";
    }
  }
};
</script>

<style scoped>
    /* ------------- Start animations ------------- */
    .hpCases.reveal .caseBox .caseBorder{
        height: 2px;
        width: 0%;
        border-bottom: solid 2px #1074b7;
        padding-bottom: 10px;
        transition: all ease 1.1s;
        transition-delay: calc(var(--addDelay) + var(--index) * 0.2s);        
    }    
    .hpCases.reveal.active .caseBox .caseBorder{
        width: 100%;
    }    
    .hpCases.reveal .caseBox .fadeUpItem{
        opacity: 0;
        transition: all ease 1.1s;
        transition-delay: calc(var(--addDelay) + (var(--index) * 0.2s));
        transform: translateY(10px);
    }
    .hpCases.reveal.active .caseBox .fadeUpItem{
        opacity: 1;
        transform: translateY(0px);
    }


    /* ------------- Start animations ------------- */


    .casesPager
    {
      clear: both;
      margin: auto;
      display: block;
      width: 66px;
      position: relative;
      top: -45px;      
    }
    .px-10vw
    {
        padding-left: 10vw;
        padding-right: 10vw;        
    }
    .hpCases
    {        
        clear: both;
        padding-top: 2vw;
        padding-bottom: 2vw;
    }
    .hpcCasesInner
    {
        background-color: #48494a;
        border-radius: 25px;
        text-align: center;
        margin: auto;   
        height: auto;     
        background-size: cover;
        background-position:  center center;
    }
    .hpCasesTitle
    {
        clear: both;
        text-align: center;
        width: 100%;
        text-transform: uppercase;
        letter-spacing: -1px !important;
        font-weight: 200 !important;
        font-size: 2.5vw; 
        color: #fff;
        padding-top:4vw;
    }
    .hpCasesBtn
    {
      clear: both;
      padding-top: 30px;
    }
    .hpCasesBtn a span
    {
      cursor: pointer;
      color: #fff;
      border: solid 2px #fff;   
      clear: both;
      width: 100%;
      display: inline;
      font-weight: 300 !important;     
      border-radius: 30px;
      padding: 10px 20px;      
      transition: all ease 0.3s;    
    }
    .hpCasesBtn a span i
    {
      padding-right: 5px;
    }
    .textLink
    {
      position: relative;
    }
    .textLink span:nth-child(2)
    {
      color: #000;
      background-color: #fff;
      position: absolute;
      top: -10px;
      left: 0px;
      clip-path: inset(100% 0 0 0 );
    }
    .textLink:hover span:nth-child(2)
    {
      clip-path: inset(0 0 0 0);
    }


    .caseBoxes
    {
        clear: both;
        padding: 3vw 6vw 6vw 6vw;        
    }   
    .caseBoxes .casesScroller
    {
        /* border: solid 5px red; */
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    .caseBoxes .casesScroller {
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none;  /* Firefox */
    }
    .caseBoxes .casesScroller::-webkit-scrollbar { 
        display: none;  /* Safari and Chrome */
    }
    .caseBoxes ul
    {
        list-style-type: none;
        display: flex;
        justify-content: space-between;
        padding: 0px;
        gap: 0px;
        flex-wrap: wrap;
        width: 204vw; /* 100-20-12vw = 68vw 68*3 pages = 204 total for the whole scroll size */
    }
    .caseBoxes ul li
    {
        flex: 1;
        cursor: pointer;
        padding: 0px 20px;
    }

    .caseBox
    {
        transition: all ease 0.6s;
        transform: translateY(0);
    }
    .caseBox .caseImg img
    {
        width: 100%;
        height: 7.5vw;
        object-fit: cover;
    }
    .caseBox .caseName
    {        
        text-align: left;
        color: #fff;
        font-weight: 500 !important;
        padding-top: clamp(8px,0.8vw,30px);        
        position: relative;
    }
    .caseTitle
    {
        padding-top: 10px;   
        text-align: left;
    }
    .caseTitle span
    {
      
        text-align: left;
        color: #fff;
        font-weight: 500 !important;
        letter-spacing: -1px;
        

/*         overflow: hidden;        
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
 */        /* height: 7vw; */
    }
    .caseView
    {
        /* border-top: solid 2px #0992e0; */
        /* padding-top: 12px; */
        /* margin-top: 12px; */
        width: 100%;
        text-align: left;
        font-weight: 300 !important;
        padding-top: 10px;
    }    
    .caseBoxes ul li .caseView span
    {
        font-weight: 400 !important;
        color: #fff;
        transition: all ease 0.4s;
    }
    .caseBoxes ul li .caseView span i
    {
      padding-right: 5px;
    }


    @media (hover: hover) {
      .caseBox:hover
      {    
        /* transform: translateY(-10px); */
        transform: scale(1.05);
      }
      .caseBoxes ul li:hover .caseView span
      {
          color: #ffffff;
      }    
    }

    @media screen and (max-width: 815px)
    {
      .hpCases        {padding: 0 0 0 0;}
      .hpcCasesInner  {border-radius: 0px;padding:6vw 0px;}
      .hpCasesTitle   {font-size: 30px;padding: 30px 0px 0px 0px;}   
      .caseBoxes      {padding: 8vw 15vw 6vw 15vw;} 
      
      .__caseBoxes ul   {display: block;}
      .__caseBox        {padding-bottom: 18px;}
      .__caseView       {padding-top: 2px;margin-bottom: 20px;}
      .__caseTitle      {height:auto;}
      
      .caseBoxes ul
      {
        /* width: 840vw; /* 12 items * 70vw */ 
        width: 350vw; /* 5 items * 70vw */
      }
      .caseBoxes ul li{
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          cursor: pointer;
          padding: 0 2vw;
          scroll-snap-align: center;
      }      
      .caseBoxes ul li:nth-child(n+6){
        display: none;
      }      


      .caseBox .caseImg img{
          height: 38vw;
      }      
      .casesPager{
        top: 0px;      
        width: 100px;
        /* display: none; */
      }      
    }


    @media only screen and (min-width:2000px)
    {
      .casesPager{
          top: initial;
          bottom: 3vw;
      }      
    }
</style>
